import { render, staticRenderFns } from "./FhConfirmDialog.vue?vue&type=template&id=54abf84d&"
import script from "./FhConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./FhConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports